import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import useTradingAccount from './useTradingAccount';

function useSecuritiesProtectedRoute() {
  const router = useRouter();
  const [isLoaded, setIsLoaded] = useState(false);
  const { isRealTrading } = useTradingAccount();

  const checkAccountType = async () => {
    if (!isRealTrading) {
      router.push('/stream');
    } else {
      setIsLoaded(true);
    }
  };

  useEffect(() => {
    checkAccountType();
  }, [isRealTrading]);

  return { isLoaded };
}

export default useSecuritiesProtectedRoute;
